import { WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { WorksheetBalanceFieldSet } from 'Components/Worksheets/Core/WorksheetEquipment';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { createPortionLabelSelector } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Helpers';
import React from 'react';
import { useSelector } from 'react-redux';
import { Field, NumericInput, TextInput, TextOutput } from '../../../../../../Core';
import { NamePrefixModifier, withInjectedProps } from '../../../../../../Core/InjectedPropsContext';
import { ListFieldSection } from '../../../../../../Layout';

let SeparationWetMassesSection: React.FC<IWorksheetComponent & { heading: string }> = ({
  createWorksheetSelector,
  namePrefix,
  heading,
}) => {
  let coarsePortionLabel = useSelector(
    createPortionLabelSelector(createWorksheetSelector!, `${namePrefix}.CoarsePortion`)
  );
  let finePortionLabel = useSelector(createPortionLabelSelector(createWorksheetSelector!, `${namePrefix}.FinePortion`));

  return (
    <ListFieldSection heading={heading}>
      {/* Shared Fields - use coarse portion as primary field and copy to fine portion */}
      <WorksheetBalanceFieldSet
        label="Balance"
        name="CoarsePortion.Masses.MassMeasurement.Equipment.Balance"
        copyTo={[
          'CoarsePortion.Masses.MassMeasurement.Equipment.DryMassBalance',
          'FinePortion.Masses.MassMeasurement.Equipment.Balance',
        ]}
      />
      <Field
        input={<WorksheetEquipmentDropdown />}
        name="CoarsePortion.Masses.MassMeasurement.Equipment.Oven"
        label="Oven"
        equipmentType="oven"
        copyTo={['FinePortion.Masses.MassMeasurement.Equipment.Oven']}
      />
      <Field
        input={<TextInput />}
        name="CoarsePortion.Masses.MassMeasurement.TareID"
        label="Tare ID"
        maxLength={20}
        copyTo={['FinePortion.Masses.MassMeasurement.TareID']}
      />
      <Field
        input={<NumericInput />}
        name="CoarsePortion.Masses.MassMeasurement.TareMass"
        label="Tare Mass"
        copyTo={['FinePortion.Masses.MassMeasurement.TareMass']}
      />

      <NamePrefixModifier appendNamePrefix={`CoarsePortion.Masses.MassMeasurement`}>
        <Field input={<NumericInput />} name="TareAndWetMass" label={`Tare and ${coarsePortionLabel} Wet Mass`} />
        <Field input={<TextOutput />} name="WetMass" label={`${coarsePortionLabel} Wet Mass`} />
      </NamePrefixModifier>

      <NamePrefixModifier appendNamePrefix={`FinePortion.Masses.MassMeasurement`}>
        <Field input={<NumericInput />} name="TareAndWetMass" label={`Tare and ${finePortionLabel} Wet Mass`} />
        <Field input={<TextOutput />} name="WetMass" label={`${finePortionLabel} Wet Mass`} />
      </NamePrefixModifier>

      <NamePrefixModifier appendNamePrefix={`CoarsePortion.Masses.MassMeasurement`}>
        <Field input={<NumericInput />} name="TareAndDryMass" label={`Tare and ${coarsePortionLabel} Dry Mass`} />
        <Field input={<TextOutput />} name="DryMass" label={`${coarsePortionLabel} Dry Mass`} />
      </NamePrefixModifier>
    </ListFieldSection>
  );
};

SeparationWetMassesSection = withInjectedProps(SeparationWetMassesSection);

export { SeparationWetMassesSection };
export default SeparationWetMassesSection;
